
<div class="dg-modal-header">
    <h2>{{popupTitle}}</h2>
    <button type="button" (click)="action(false)" class="close-icon icon-cross_16px" style="border:none;background:transparent;"></button>
</div>

<div class="dg-modal-body">

    <span>Please select a new delivery location in the field below.</span>

    <div class="delivery-location">

        <b>Delivery location</b>
        <div class="dropdown-block">
            <button type="button" class="head" (click)="toggle()">
                <span [class.empty]="!newDeliveryLocation.key">{{newDeliveryLocation.value || 'Select'}}</span>
                <i class="icon-arrow-expand arrow-icon" [class.opened]="isLocationDropdownOpen"></i>
            </button>
                <div *ngIf="isLocationDropdownOpen" class="list">
                    <div class="search-wrapper" >
                        <div class="search-section">
                            <input type="text"
                                [(ngModel)]="filterQuery"
                                (ngModelChange)="setFilterQuery($event)"
                                placeholder="Search"
                                maxlength="50"
                                (focus)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()">
                            <i class="icon-search"></i>
                            <button id="clear-filter-search"
                                appTrackClickButton
                                type="button"
                                class="icon-cross_16px clear-control"
                                [hidden]="!filterQuery.length"
                                (click)="$event.stopPropagation(); setFilterQuery('')">
                            </button>
                        </div>
                    </div>

                    <ng-container *ngTemplateOutlet="hasFilteredResults ? optionsList : emptyList"></ng-container>

                    <ng-template #optionsList>
                        <div class="options-wrapper">
                            <button type="button" *ngFor="let option of deliveryLocationOptions | listFilter: filterBy : false"
                            class="option"
                            (click)="locationChanged(option); toggle()"
                            style="border:none;background:transparent;margin:0;font:inherit;color:inherit;text-align:inherit;width:100%;display:block;">

                                <div class="option-label">
                                    <span [innerHTML]="option.value | htmltransfrom | highlight: pipeFilterQuery"></span>
                                </div>
                            </button>
                        </div>
                    </ng-template>

                    <ng-template #emptyList>
                        <div class="options-empty">No delivery locations found</div>
                    </ng-template>
                </div>
            </div>
        </div>
</div>
<div class="dg-modal-footer">
    <button
        (click)="action(false)"
        appTrackClickButton
        id="dismiss"
        type="button"
        class="button secondary"
        >{{ buttonsTitle.dismiss }}
    </button>

    <button
        (click)="submit()"
        [disabled]="!newDeliveryLocation.key"
        appTrackClickButton
        id="confirm"
        type="button"
        class="button primary"
        >{{ buttonsTitle.confirm }}
    </button>
</div>
